import AnnouncementsHeader from './AnnouncementsHeader';

export default AnnouncementsHeader;
